<template>
  <div >
    <portlet :clase="'container col-md-12 blockui_sample_3_2_element'" > 
      <template slot="actions"> 
        <a class="btn btn-circle btn-icon-only btn-success" title='Descargar Excel' v-on:click="rdownload()"><i class="fa fa-file-excel-o"></i></a>          
        <a class="btn btn-circle btn-icon-only green" href="#portlet-config" data-toggle='modal' title='Agregar Costo' v-on:click="nuevoCosto()" ><i class="fa fa-plus"></i></a>
      </template>
      <template slot="caption">
        <div class="row"> 
          <div class='col-md-6'>          
              <span class="caption-subject bold uppercase"> 
                  <i class="fa fa-database"></i>  Configurar Costos 
                  &nbsp;<a class="btn btn-circle btn-icon-only btn-default" title='Recargar registros' v-on:click="loadTableSample()"><i class="fa fa-rotate-left"></i></a>
              </span>         
          </div>          
        </div>  
      </template>      
      <template slot="body">         
        <div class="row">           
          <tableSample :lengthMenu="lengthMenu" @accionEditar="costoEditar" @accionEliminar="eliminarRegistro" @accionPorcentaje="editarPorcentaje" @accionSubsidio="editarSubsidio" :data_="data_" :id="'sample_2'" v-if="renderTable"/>  
        </div>
      </template>
    </portlet>
    <modalconfirmation :id="'portlet-deleted'" >      
      <template slot="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
        <h4 class="modal-title"> DETALLE DEL REGISTRO A ELIMINAR</h4>
      </template>
      <template slot="modal-body">
        <p><strong>Tramite:</strong> {{detalle_tramite}}</p>
        <p><strong>Tipo:</strong> {{detalle_tipo}}</p>
      </template>
      <template slot="modal-footer">
        <button type="button" data-dismiss="modal" class="btn default">Cancelar </button>
        <button type="button" data-dismiss="modal" class="btn green" v-on:click="deletedCosto()"><i class="fa fa-check"></i> Aceptar</button>
      </template>
    </modalconfirmation>
    <modal :id="'portlet-config'" :modal="'modal-md'" >
      <template slot="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="closeConfig()"></button>
          <h4 class="modal-title"><i class="fa fa-cogs"></i> Padrón Licencia Alcoholes</h4>
      </template>
      <template slot="modal-body">
        <div class="row">
          <div class="col-md-12 form-group">
            <label>Tramite</label>
            <select2 class="form-control" :options="options" v-model="tramite" @eventchange="changeTramite()">
              <option :value="0">--------</option>
              <option v-for="b in listTramites" :value="b.id"> {{ b.nombre}}</option>
            </select2>
          </div>
          <div class="col-md-12 form-group">
            <label >Tipo</label>
            <select2 class="form-control" :options="options" v-model="tipo_costo" @eventchange="changeTipo()">
              <option :value="0">--------</option>
              <option v-for="b in listTipoCostos" :value="b.id"> {{ b.name}}</option>
            </select2>
          </div>
          <div class="col-md-12 form-group text-center" v-if="hidden_costoVariable">
            <label >Tipo de Operación</label>
            <span class="help-block">Selecciona una Opcion. </span>
            <div class="md-radio-inline">
              <div class="md-radio">
                <input type="radio" id="radio6" name="tipoOperacion" class="md-radiobtn" value="H" v-on:click="changeTipoOperacion('H')">
                <label for="radio6"> <span></span><span class="check"></span><span class="box"></span>Hoja.</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio7" name="tipoOperacion" class="md-radiobtn" value="M" v-on:click="changeTipoOperacion('M')">
                  <label for="radio7"><span></span><span class="check"></span><span class="box"></span>Millar.</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio8" name="tipoOperacion" class="md-radiobtn" value="L" v-on:click="changeTipoOperacion('L')">
                <label for="radio8"><span></span><span class="check"></span><span class="box"></span>Lote.</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio9" name="tipoOperacion" class="md-radiobtn" value="C" v-on:click="changeTipoOperacion('C')">
                <label for="radio9"><span></span><span class="check"></span><span class="box"></span>Campo.</label>
              </div>
            </div>
          </div>
          <div class="col-md-12 form-group" v-if="hidden_variable">
            <label >Cantidad mínima en cuotas</label>
            <input type="text" class="valida-decimal form-control" name="cuotaMin" v-model="v_cantidad_minima" placeholder="Ingrese Cuota Minima..." autocomplete="off">
          </div>
          <div class="col-md-12 form-group" v-if="hidden_variable">
            <label >Cantidad máximo en cuotas</label>
            <input type="text" class="valida-decimal form-control" name="cuotaMax" v-model="v_cantidad_maxima" placeholder="Ingrese la Cuota Máximo..." autocomplete="off">
          </div>
          <div class="col-md-12 form-group" v-if="hidden_variable">
            <label >Costo por Tipo de operación (MXN)</label>
            <input type="text" class="valida-decimal form-control" name="valor" v-model="v_costo_operacion" placeholder="Ingrese el valor de la operacion Ej. 0.50" autocomplete="off">
          </div>
          <div class="col-md-12 form-group" v-if="hidden_variable">
            <div class='md-checkbox'>
              <input type='checkbox' id='checkbox1' name="multiple" class='md-check'  v-on:change="changeMultiple()">
              <label for='checkbox1'><span></span><span class='check'></span> <span class='box'></span>¿Este costo puede ser multiple?</label>
            </div>
          </div>
          <div class="col-md-12 form-group text-center" v-if="hidden_costoMultiple">
            <label >Tipo de Operación</label>
            <span class="help-block">Selecciona una Opcion. </span>
            <div class="md-radio-inline">
              <div class="md-radio">
                <input type="radio" id="radio12" name="varibleTipo" class="md-radiobtn" value="H" >
                <label for="radio12"> <span></span><span class="check"></span><span class="box"></span>Hoja.</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio13" name="varibleTipo" class="md-radiobtn" value="L" >
                <label for="radio13"><span></span><span class="check"></span><span class="box"></span>Lote. </label>
              </div>
            </div>
          </div>
          <div class="col-md-12 form-group" v-if="hidden_costoMultiple">
            <label >Cantidad mínima en cuotas</label>
            <input type="text" class="valida-decimal form-control" name="cuotaMin2" v-model="m_cantidad_minima" placeholder="Ingrese Cuota Minima..." autocomplete="off">
          </div>
          <div class="col-md-12 form-group" v-if="hidden_costoMultiple"> 
            <label >Costo por Tipo de operación (MXN)</label>
            <input type="text" class="valida-decimal form-control" name="valor2" v-model="m_costo_operacion" placeholder="Ingrese el valor de la operacion Ej. 0.50" autocomplete="off">
          </div>
          <div class="col-md-12 form-group" v-if="hidden_campoCosto">
            <label >Campo</label>
             <select2 class="form-control" :options="options" v-model="c_campo">
              <option :value="0">--------</option>
              <option v-for="b in listCampos" :value="b.relacion_id"> {{ b.campo_nombre}}</option>
            </select2>
          </div>
          <div class="col-md-12 form-group" v-if="hidden_campoCosto"><span class="help-block">&nbsp;</span>
            <div class="alert alert-warning alert-dismissable">
              <strong>Nota: </strong>Para mostrar los campo es necesario configurar el campo tipo <strong>Input</strong> al tramite en <strong>Portal->Configuración Trámites->Configuración de Campos</strong>
            </div>
          </div>
          <div class="col-md-12 form-group" v-if="hidden_costoFijo">
            <span class="help-block">Selecciona una Opcion. </span>
            <div class="md-radio-inline">
              <div class="md-radio">
                <input type="radio" id="radio4" name="tipoValor" class="md-radiobtn" value="C" >
                <label for="radio4"><span></span><span class="check"></span><span class="box"></span>Cuota.</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio5" name="tipoValor" class="md-radiobtn" value="P" >
                <label for="radio5"><span></span><span class="check"></span><span class="box"></span>Pesos.</label>
              </div>
            </div>
          </div>
          <div class="col-md-12 form-group" v-if="hidden_costoFijo">
            <label >Precio del trámite</label>
            <input type="text" class="valida-decimal form-control" name="fijo" v-model="f_precio" placeholder="Ingrese el costo fijo del trámite" autocomplete="off">
          </div>
        </div>
      </template>
      <template slot="modal-footer"> 
        <button type="button" class="btn default" data-dismiss="modal" v-on:click="closeConfig()">Cerrar</button>
        <button type="button" class="btn blue" v-on:click="validaciones()"><i class="fa fa-check"></i> Guardar</button>
      </template>  
    </modal>
    <modal :id="'portlet-subsidio'" :modal="'modal-md'">
      <template slot="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearModal()"></button>
        <h4 class="modal-title"><i class="fa fa-cogs"></i> Configuracion Subsidio</h4>
      </template>
      <template slot="modal-body">
        <div class="row">
          <div class="col-md-12 form-group">
            <label>Partida</label>
            <select2 class="form-control" :options="options" v-model="s_partida" @eventchange="changeTramite()">
              <option :value="0">--------</option>
              <option v-for="b in listPartidas" :value="b.id">{{ b.id }} - {{ b.desc}}</option>
            </select2>
          </div>
          <div class="col-md-12 form-group">
            <label>Cuotas a cobrar</label>
            <input type="text" class="form-control valida-decimal" placeholder="Ingresar cuotas a cobrar" v-model="s_cuotas_cobro" name="s_valor_cuota">
          </div>
          <div class="col-md-12 form-group">
            <label>Limite de cuotas elevadas al año</label>
            <input type="text" class="form-control valida-decimal" placeholder="Ingresar limite de cuotas"  v-model="s_limite_cuota" name="s_valor_cuota" >
          </div>
          <div class="col-md-12 form-group">
            <label># de oficio ó decreto</label>
            <input type="text" class="form-control" placeholder="Ingresar el # de oficio"  v-model="s_oficio_decreto" name="s_valor_cuota">
          </div>
          <div class="col-md-12 form-group text-center">
            <label>Tipo de Persona aplicable</label>
            <span class="help-block">Selecciona una Opcion. </span>
            <div class="md-radio-inline">
              <div class="md-radio">
                <input type="radio" id="radio14" name="tipoPersona" class="md-radiobtn" value="pf" >
                <label for="radio14"> <span></span><span class="check"></span><span class="box"></span>Persona Fisica</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio15" name="tipoPersona" class="md-radiobtn" value="pm" >
                <label for="radio15"><span></span><span class="check"></span><span class="box"></span>Persona Moral</label>
              </div>|
              <div class="md-radio">
                <input type="radio" id="radio16" name="tipoPersona" class="md-radiobtn" value="a" >
                <label for="radio16"><span></span><span class="check"></span><span class="box"></span>Ambos </label>
              </div>
            </div>
          </div>
          <div class="col-md-12 form-group">
            <label>Valor de cuota</label>
            <input type="text" class="form-control" placeholder="Valor de couta" name="s_valor_cuota" v-model="s_valor_cuota" disabled>
          </div>
        </div>
      </template>
      <template slot="modal-footer"> 
        <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearModal()">Cerrar</button>
        <button type="button" class="btn blue" v-on:click="validaSubsidio()"><i class="fa fa-check"></i> Guardar</button>
      </template>  
    </modal>
     <modal :id="'portlet-porcentaje'" :modal="'modal-md'">
       <template slot="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" v-on:click="clearModal()"></button>
        <h4 class="modal-title"><i class="fa fa-cogs"></i>Editar Procentaje</h4>
      </template>
      <template slot="modal-body">
        <div class="row">
          <div class="col-md-12 form-group">
            <label>Porcentaje&nbsp;<a  class=" popovers"  data-trigger="hover" data-placement="top" data-content="El valor del porcentaje debe ser el valor de porcentaje a cobrar.." data-original-title="Información"><i class="fa fa-question-circle"></i></a></label>
            <input type="text" class="form-control valida-numeros" placeholder="Ingresar el porcentaje" v-model="porcentaje" name="p_porcentaje" maxlength="3">
            <span class="help-block">{{ rango_porcentaje }}</span>
          </div>
        </div>
      </template>
      <template slot="modal-footer"> 
        <button type="button" class="btn default" data-dismiss="modal" v-on:click="clearModal()">Cerrar</button>
        <button type="button" class="btn blue" v-on:click="savePorcentaje()"><i class="fa fa-check"></i> Guardar</button>
      </template>  
    </modal>
  </div>
</template>  
<script>
  import axios from 'axios'
  import select2 from './General/Select.vue'
  import portlet from './General/Portlet.vue'
  import modal from './General/Modal.vue'
  import modalconfirmation from './General/ModalConfirmation.vue'
  import tableSample from './Individual/TableCostos.vue'
  import VCalendar from 'v-calendar'
  import * as XLSX from 'xlsx'
  import { saveAs } from 'file-saver'
import { set } from 'lodash'

  export default {
    name: 'ReporteEstadistica',
    components: {axios,select2,portlet,modal,modalconfirmation,tableSample,VCalendar},
    data(){
      return{
        data_:[],
        renderTable:false,
        lengthMenu:[10,25,50,100,"All"],
        options:[],
        listTramites:[],
        listCoutas:[],
        listPartidas:[],
        listCampos:[],
        hidden_campoCosto:false,
        hidden_costoVariable:false,
        hidden_costoFijo:false,
        hidden_costoMultiple:false,
        hidden_variable:false,
        detalle_tramite:'',    
        detalle_tipo:'',
        listTipoCostos:[
          {id:'F',name:'Fijo'},
          {id:'V',name:'Variable'},
          {id:'I',name:'Impuesto'},
        ],
        id_registro:0,
        tramite:0,
        tipo_costo:0,
        tipo_operacion:'',
        v_cantidad_minima:'',
        v_cantidad_maxima:'',
        v_costo_operacion:'',
        m_tipo_operacion:'',
        m_cantidad_minima:'',
        m_costo_operacion:'',
        c_campo:'',
        f_tipo:'',
        f_precio:'',
        id_subsidio:0,
        s_partida:0,
        s_cuotas_cobro:'',
        s_limite_cuota:'',
        s_oficio_decreto:'',
        s_valor_cuota:'',
        porcentaje:'',
        rango_porcentaje:''
      }
    },
    methods:{
      loadTableSample(){
        this.renderTable=false;
        this.loagingC(true);
        this.data_=[];                  
        axios.get(`${process.env.APP_URL}/traux-get-costos`)
          .then((response)=>{                     
            this.data_=response.data; 
            this.loagingC(false);
            this.renderTable=true;
          })
          .catch(error=>{
            console.log(error);
            this.loagingC(false);                    
          }
        );
      },
      findTramite(tramite){
        axios.get(`${process.env.APP_URL}/traux-find-tramites/${tramite}`)
          .then((response)=>{                     
            this.listTramites=response.data;
            setTimeout(()=>{
              this.tramite=tramite ? tramite : 0;
            },100);
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      validaciones(){
        if(this.tramite==0){
          this.notifications("400","Seleccione un tramite");
          return false;
        }
        if(this.tipo_costo==0){
          this.notifications("400","Seleccione un Tipo");
          return false;
        }
        if(this.tipo_costo=='F'){
          if($('input[name=tipoValor]:checked').length==0){
            this.notifications("400","Seleccione un opcion del costo");
            return false;
          }
          if(this.f_precio==''){
            this.notifications("400","Ingrese el precio del trámite");
            return false;
          }
        }else if(this.tipo_costo=='V'){
          let option=$('input[name=tipoOperacion]:checked').val();
          if(option=="C"){
            if(this.c_campo==0){
              this.notifications("400","Seleccione un campo configurado");
              return false;
            }
          }else if(option=="H" || option=="M" || option=="L"){
            if(this.v_cantidad_minima==''){
              this.notifications("400","Ingrese la cantidad mínima en cuotas");
              return false;
            }
            if(this.v_cantidad_maxima==''){
              this.notifications("400","Ingrese la cantidad máxima en cuotas");
              return false;
            }
            if(this.v_costo_operacion==''){
              this.notifications("400","Ingrese el costo por tipo de operación (MXN)");
              return false;
            }
            let multiple=$("#checkbox1").prop("checked") ? true : false;
            if(multiple){
              let optionM=$('input[name=varibleTipo]:checked').val();
              if(optionM=='' || optionM==undefined){
                this.notifications("400","Seleccione un tipo de operación");
                return false;
              }
              if(this.m_cantidad_minima==''){
                this.notifications("400","Ingrese la cantidad mínima en cuotas");
                return false;
              }
              if(this.m_costo_operacion==''){
                this.notifications("400","Ingrese el costo por tipo de operación (MXN)");
                return false;
              }
            }
          }else{
            this.notifications("400","Seleccione un tipo de operación");
            return false;
          }        
        }
        let r_data={
          tramite: this.tramite,
          tipo: this.tipo_costo,
          costo: $('input[name=tipoOperacion]:checked').val(),
          tipo_costo_fijo: $('input[name=tipoValor]:checked').val(),
          fijo: this.f_precio,
          minimo:this.v_cantidad_minima,
          maximo:this.v_cantidad_maxima, 
          valor: this.v_costo_operacion, 
          regla_id:null,
          multiple: $("#checkbox1").prop("checked") ? 1 : 0, 
          var_costo: $('input[name=varibleTipo]:checked').val(), 
          cuotamin2: this.m_cantidad_minima, 
          valor2: this.m_costo_operacion, 
          vigencia:null
        };
        this.relacionCampo();
        if(this.id_registro==0 || this.id_registro=='0'){
          this.saveCosto(r_data);
          console.log("guardar");
        }else{
          r_data= Object.assign(r_data, {id:this.id_registro});
          console.log("editar");
          this.editCosto(r_data);
        }
        return true;
      },
      saveCosto(r_data){
        axios.post(`${process.env.APP_URL}/traux-post-tramites`,r_data)
          .then((response)=>{                     
            if(response.data.Code =="200"){
              this.notifications("200",response.data.Message);
              this.tramite=0;
              this.tipo_costo=0;
              this.changeTipo();
              this.clearModal();
              this.loadTableSample();
            }else{ this.notifications("400",response.data.Message);}
          })
          .catch(error=>{
            console.log(error);
          }
        );
      },
      editCosto(r_data){
        axios.post(`${process.env.APP_URL}/traux-edit-tramites`,r_data)
          .then((response)=>{                     
            if(response.data.Code =="200"){
              this.notifications("200",response.data.Message);
              this.loadTableSample();
            }else{ this.notifications("400",response.data.Message);}
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      relacionCampo(){
        let campo_=this.campo == 0 ?  'limpia': this.c_campo;
        axios.post(`${process.env.APP_URL}/traux-update-relacion`,{ id_tramite: this.tramite,id_relacion: campo_})
          .then((response)=>{                     
            if(response.data.Code =="200"){
              //this.notifications("200",response.data.Message);               
              this.loadTableSample();
            }else{ this.notifications("400",response.data.Message);}
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      costoEditar(data){
        this.id_registro=data.id;
        this.tramite=data.tramite_id;
        this.findTramite(data.tramite_id);
        this.tipo_costo=data.tipo;
        //this.findCampos();
        if(data.tipo=='F'){
          setTimeout(() => {
            this.f_precio=data.costo_fijo;
          $('input[name=tipoValor][value='+data.tipo_costo_fijo+']').attr('checked', true);
          }, 100);
        }else if(data.tipo=='V'){
            setTimeout(() => {
              $('input[name=tipoOperacion][value='+data.costo+']').attr('checked', true);
              this.hidden_variable=true;
              this.changeTipoOperacion(data.costo);
            }, 100); 
            setTimeout(() => {
              this.v_cantidad_minima=data.minimo;
              this.v_cantidad_maxima=data.maximo;
              this.v_costo_operacion=data.valor;
            }, 200); 
            if(data.variable==1){
              setTimeout(() => {
                $("#checkbox1").prop("checked", true);
                this.hidden_costoMultiple=true;
              }, 200);
              setTimeout(() => {
                $('input[name=varibleTipo][value='+data.var_costo+']').attr('checked', true);
              }, 300);
              setTimeout(() => {
                this.m_cantidad_minima=data.var_minimo;
                this.m_costo_operacion=data.var_valor;
              }, 400);
            }
            if(data.costo=='C'){  
              setTimeout(() => {
                this.hidden_campoCosto=true;
                //this.c_campo=data.campo_id;
              },300);
            }
          
        }else{
          
        }
      },
      editarSubsidio(data){
        this.id_subsidio=data.subsidio_id;
        this.id_registro=data.id;
        //this.findPartidas(data.tramite_id);
        this.s_partida=data.id_partida;
        this.s_cuotas_cobro=data.cuotas;
        this.s_limite_cuota=data.limite_cuotas;
        $('input[name=tipoPersona][value='+data.tipoPersona+']').attr('checked', true);
        this.s_oficio_decreto=data.oficio;
      },
      validaSubsidio(){
        let tipo=$('input[name=tipoPersona]:checked').val();
        if(this.s_partida==0){
          this.notifications("400","Seleccione una partida, Requerido!");
          return false;
        }else if(this.s_cuotas_cobro.length==0){
          this.notifications("Campo cuota, Requerido!");
          return false;
        }else if(this.s_limite_cuota.length==0){
          this.notifications("Campo limite de cuota, Requerido!");
          return false;
        }else if(tipo==null){
          this.notifications("Campo tipo persona, Requerido!");
          return false;
        }
        this.saveSubsidio();
      },
      saveSubsidio(){
        let tipo=$('input[name=tipoPersona]:checked').val();
        axios.post(`${process.env.APP_URL}/traux-post-subsidios`,
        {id:this.id_subsidio,
          tramite:this.tramite,
          costo_id:this.id_registro,
          cuotas:this.s_cuotas_cobro,
          oficio:this.s_oficio_decreto,
          limite_cuotas:this.s_limite_cuota,
          partida:this.s_partida,
          optionPersona:tipo})
          .then((response)=>{                     
            if(response.data.Code =="200"){
              this.notifications("200",response.data.Message);               
              this.loadTableSample();
            }else{ this.notifications("400",response.data.Message);}
          })
          .catch(error=>{
            console.log(error);                   
          });
      },
      editarPorcentaje(id,porcentaje_){
        this.id_registro=id;
        this.porcentaje=porcentaje_ == 'null' ? '':porcentaje_ ;
      },
      savePorcentaje(){
        if(this.porcentaje.length==0 || this.porcentaje>100 || this.porcentaje<1){
          this.notifications("400","Porcentaje requerido");
        }
        axios.post(`${process.env.APP_URL}/traux-edit-porcentaje`,
        {id:this.id_registro,porcentaje:porcentaje_})
          .then((response)=>{                     
            if(response.data.Code =="200"){
              this.notifications("200",response.data.Message);               
              this.loadTableSample();
            }else{ this.notifications("400",response.data.Message);}
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      changeTramite(){
        this.c_campo=0;
        if(this.tramite!=0){
          this.findCampos();
        }else{
          this.listCampos=[];
        }
      },
      findCampos(){
        axios.post(`${process.env.APP_URL}/traux-find-campos`,{id_tramite:this.tramite})
          .then((response)=>{                     
            this.listCampos=response.data;
            let valor_op= this.listCampos.find(item => JSON.parse(item.caracteristicas).valor_operacion===true)

            if(valor_op){
              this.c_campo=valor_op.relacion_id;
            }
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      findPartidas(){
        axios.get(`${process.env.APP_URL}/traux-get-partida`)
          .then((response)=>{                     
            this.listPartidas=response.data;
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      findCuotas(){
        axios.get(`${process.env.APP_URL}/traux-get-cuota`)
          .then((response)=>{                     
            this.s_valor_cuota=response.data.cuota_costo;
          })
          .catch(error=>{
            console.log(error);                   
          }
        );
      },
      changeTipo(){
        this.hidden_campoCosto=false;
        this.hidden_costoVariable=false;
        this.hidden_costoFijo=false;
        this.hidden_costoMultiple=false;
        this.hidden_variable=false;
        if(this.tipo_costo=='F'){
          this.hidden_costoFijo=true;
        }else if(this.tipo_costo=='V'){
          this.hidden_costoVariable=true;
        }
        $('input[name=tipoOperacion]').attr('checked', false);
        this.clearFormCosto();
      },
      closeConfig(){
        this.tramite=0;
        this.tipo_costo=0;
        this.clearFormCosto();
        $('input[name=tipoOperacion]').attr('checked', false);

      },
      changeTipoOperacion(tipo){
        this.hidden_campoCosto=false;
        this.hidden_variable=false;
        this.hidden_costoMultiple=false;
        if(tipo=='C'){
          this.hidden_campoCosto=true;
        }else{
          this.hidden_variable=true;
        }
        this.clearFormCosto();
      },
      changeMultiple(){
        let check=$("#checkbox1").prop("checked") ? true : false;
        this.hidden_costoMultiple=false;
        if(check){
          this.hidden_costoMultiple=true;
        }
      },
      eliminarRegistro(id,tramite,tipo){
        this.id_registro=id;
        this.detalle_tramite=tramite;
        this.detalle_tipo=this.tipo(tipo);
      },
      deletedCosto(){
        axios.post(`${process.env.APP_URL}/traux-del-tramites`,{id:this.id_registro})
          .then((response)=>{
            if(response.data.Code =="200"){
              this.notifications("200",response.data.Message);
              this.loadTableSample();
            }else{ this.notifications("400",response.data.Message);}
            this.id_registro=0; // evita que el siguiente "+" entre en modo editar
          })
          .catch(error=>{
            console.log(error);
          }
        );
      },
      // Botón "+" Agregar Costo: resetea estado para que SIEMPRE inserte (no edite el último)
      nuevoCosto(){
        this.clearFormCosto();
        this.id_registro=0;
        this.tipo_costo=0;
        this.changeTipo();
        this.findTramite(0);
      },
      clearModal(){
        this.id_registro='';
        this.clearFormCosto();
      },
      clearFormCosto(){        
        this.id_subsidio='';
        this.tipo_operacion='';
        this.v_cantidad_minima='';
        this.v_cantidad_maxima='';
        this.v_costo_operacion='';
        this.m_tipo_operacion='';
        this.m_cantidad_minima='';
        this.m_costo_operacion='';
        this.c_campo=0;
        this.f_tipo='';
        this.f_precio='';
        $('input[name=tipoValor').attr('checked', false);
        $('input[name=variableTipo').attr('checked', false);
        $('input[name=varibleTipo').attr('checked', false);
        $("#checkbox1").prop("checked", false);
        this.porcentaje='';
        this.s_partida='0';
        this.s_cuotas_cobro='';
        this.s_limite_cuota='',
        this.s_oficio_decreto='';
        $('input[name=tipoPersona').attr('checked', false);
      },
      rdownload() {
        if(this.data_.length==0){
          this.notifications('400',"Sin registros");
          return;
        }
        let mappedData = this.data_.map(item => ({
          "TRAMITE:": item.tramite,
          "ID TRAMITE": item.tramite_id,
          "TIPO": item.tipo == 'F' ? 'Fijo' : item.tipo == 'V' ? 'Variable' : 'Impuesto',
          "TIPO DE OPERACION": item.costo == 'H' ? 'Hoja' : item.costo == 'M' ? 'Millar' : item.costo == 'L' ? 'Lote' : item.costo == 'C' ? 'Campo' : 'N/A',
          "CUOTA MINIMA": item.minimo == null ? 'N/A' : item.minimo,
          "CUOTA MAXIMA": item.maximo== null ? 'N/A' : item.maximo,
          "COSTO": item.valor== null ? 'N/A' : item.valor,
          "TIPO DE COSTO FIJO": item.tipo_costo_fijo== 'P' ? 'N/A' : item.tipo_costo_fijo == 'C' ? 'Cuota' : 'N/A',
          "COSTO FIJO": item.costo_fijo== null ? 'N/A' : item.costo_fijo,
          "PORCENTAJE": item.porcentaje==null ? 'N/A' : item.porcentaje,
          "PARTIDA": item.partida==null ? 'N/A' : item.id_partida,
          "OFICIO": item.oficio==null ? 'N/A' : item.oficio,
          "TIPO PERSONA": item.tipoPersona== null ? 'N/A' :item.tipoPersona=="pf" ? 'Física' : item.tipoPersona=="pm" ? 'Moral' : 'Ambos',
          "CUOTAS A COBRAR": item.cuotas==null ? 'N/A' : item.cuotas,
          "LIMITE DE CUOTAS ELEVADAS AL AÑO": item.limite_cuotas==null ? 'N/A' : item.limite_cuotas,
          "COSTO MULTIPLE": item.variable== null ? 'N/A' :  item.variable==0 ? 'NO' : 'SI',
          "TIPO OPERACION": item.var_costo== null ? 'N/A' : item.var_costo == 'L' ? 'LOTE' : 'HOJA',
          "CANTIDAD MINIMA DE CUOTAS": item.var_minimo==null ? 'N/A' : item.var_minimo,
          "COSTO POR TIPO DE OPERACION(MXN)": item.var_valor==null ? 'N/A' : item.var_valor,
          "VIGENCIA": item.vigencia==null ? 'N/A' : item.vigencia,
        }));
        let nombre='REPORTE COSTOS -';
        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const xlsxData = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([xlsxData], { type: 'application/octet-stream' });
        saveAs(blob, nombre +'.xlsx');
      },
      loagingC(value, index, values) {
          return Vue.filter('loadingCharge')(value);
      },
      notifications(Code,Message){
        if(Code=="200"){
          Command: toastr.success(Message, "Notifications");
        }else{
          Command: toastr.warning(Message, "Notifications");
        }
      },
        tipo(tipo){
        if(tipo=='F'){tipo="Fijo";}else if(tipo=='I'){tipo="Impuesto";}else{tipo="Variable";}
        return tipo;
      },
    },
    mounted() {
      this.loadTableSample();
      this.findTramite(0);
      this.findCuotas();
      this.findPartidas();
    },
    watch:{
      porcentaje(porcentaje){
        this.rango_porcentaje="";
        if(porcentaje>100){
          this.rango_porcentaje="Rango sobrepasado...";
        }
      }
    }
  }
</script>